<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.cardiacExam') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-form>
                                <b-container>
                                    <b-row>
                                        <b-col sm="12">
                                            <span  class="obligatoire">*</span>

                                            <b-form-group
                                                    id="name-group"
                                                    :label="$t('message.select')+' '+$t('message.name')"
                                                    label-for="name"
                                                    class="mt-2"
                                            >
                                                <!-- Options -->
                                                <select id="name"
                                                        v-model="$v.form.nom.$model"
                                                        class="form-control is-invalid retirerBordure"
                                                        required
                                                        :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                                        @focus="clearErrorField('nom')"
                                                >
                                                    <option v-for="item in noms" :value="item" :key="item">
                                                        {{ item }}
                                                    </option>
                                                </select>

                                                <b-form-invalid-feedback v-if="$v.form.nom.$error">
                                                    {{ $t('message.requiredField') }}
                                                </b-form-invalid-feedback>

                                                <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                                    {{ getErrorsField('nom') }}
                                                </b-form-invalid-feedback>

                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12">
                                            <span  class="obligatoire">*</span>
                                            <b-form-group
                                                    id="date-group"
                                                    :label="$t('message.startDate')"
                                                    label-for="date"
                                            >
                                                <b-form-input
                                                        id="date"
                                                        v-model="$v.form.date_examen.$model"
                                                        :state="$v.form.date_examen.$dirty ? !(errorshasField('date') || $v.form.date_examen.$error) : null"
                                                        type="date"
                                                        required
                                                        @click="clearErrorField('date')"
                                                ></b-form-input>

                                                <b-form-invalid-feedback v-if="$v.form.date_examen.$error">
                                                    {{ $t('message.requiredField') }}
                                                </b-form-invalid-feedback>
                                                <span v-if="errorshasField('date_examen')" style="color:red">
                                    {{getErrorsField('date')}}
                                    </span>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="12">
                                            <span  class="obligatoire">*</span>

                                            <b-form-group
                                                    id="description-group"
                                                    :label="$t('message.description')"
                                                    label-for="description"
                                            >
                                                <b-form-textarea
                                                        id="description"
                                                        v-model="$v.form.description.$model"
                                                        :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                                        required
                                                        @focus="errorshasField('description')"
                                                ></b-form-textarea>
                                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                                    {{ $t('message.requiredField') }}
                                                </b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                                    {{ $t('message.minCharacters', { n: 3 }) }}
                                                </b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="errorshasField('description')">
                                                    {{ getErrorsField('description') }}
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="1">
                                        </b-col>
                                    </b-row>
                                    <b-row class="justify-content-sm-center mb-2" v-if="can">
                                        <b-button @click="onSubmit" variant="primary">
                                            {{ $t('message.save') }}
                                        </b-button>
                                    </b-row>
                                </b-container>
                            </b-form>
                        </div>
                    </b-container>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SlimSelect from "slim-select";
    import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "AddCardiology",
        computed: {
            ...mapGetters(['hasAdminRole', 'hasMedecinControleRole', 'hasPraticienRole','hasAssistante']),
            can: function () {
                return this.hasAdminRole || this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
            },
        },
        data() {
            return {
                cardiologie_id: this.$route.params.cardiology,

                noms: [
                    "Echographie trans-thoracique",
                    "Echographie trans-œsophagienne",
                    "Épreuves d'effort",
                    "RX Thorax",
                    "Echographie",
                    "MAPA",
                    "Holter",
                    "Tilt test",
                    "Biologie",
                ],

                form: {

                    nom: '',

                    description: '',

                    date_examen: '',
                },

            }
        },

        methods:{
            onSubmit:function (evt) {
                evt.preventDefault();

                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let args = {
                        cardiologie_id: this.cardiologie_id,
                        nom: this.form.nom,
                        date_examen: this.form.date_examen,
                        description: this.form.description
                    };

                    let successMessage = this.$i18n.t('message.cardiacExamCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createCardioExam', {args, errorMessages, successMessage});
                }
            },

            getErrorsField(field) {
                if (this.errorshasField(field)) {
                    return this.errors[field][0];
                } else {
                    return '';
                }
            },

            errorshasField(field) {
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field) {
                this.$store.dispatch('clearErrorField', {field});

                this.getErrorsField(field);
            }
        },

        mounted() {
            new SlimSelect({
                select: '#name',
                placeholder: 'Select nom',
                limit:1
            });
        },

        validations: {
            form: {

                nom: {
                    required
                },

                description: {
                    required,
                    minLength: minLength(3)
                },

                date_examen: {
                    required
                },
            },
        }
    }
</script>

<style scoped>

</style>